import { __rest } from '../../../../../../node_modules/tslib/tslib.es6.mjs.js';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { ListBox } from 'primereact/listbox';
import { classNames } from 'primereact/utils';
import { getDataTypeIcon } from '../helpers/utils.js';
import DataType from '../types/DataType.js';

const ColumnForm = (_a) => {
    var { initialModel, mode = "create", onCancel, onCreate, onUpdate } = _a, otherProps = __rest(_a, ["initialModel", "mode", "onCancel", "onCreate", "onUpdate"]);
    const [model, setModel] = useState(initialModel !== null && initialModel !== void 0 ? initialModel : {});
    const [fieldTypeSearchQuery, setFieldTypeSearchQuery] = useState("");
    return (React.createElement("form", Object.assign({ noValidate: true, onSubmit: onSubmit }, otherProps),
        React.createElement("div", { className: "p-3 surface-900 border-round-top" },
            React.createElement("label", { className: "inline-block mb-2", htmlFor: "field-name" }, "Field Name"),
            React.createElement(InputText, { className: "w-full", id: "field-name", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { fieldName: e.target.value })), placeholder: "Field Name Optional", value: model.fieldName })),
        model.dataType == null && (React.createElement("div", { className: "surface-600 border-round-bottom" },
            React.createElement("div", { className: "px-3 pt-3" },
                React.createElement("div", { className: "relative" },
                    React.createElement("span", { className: "pi pi-search absolute top-50 ml-2", style: { marginTop: "-.5rem" } }),
                    React.createElement(InputText, { className: "w-full pl-5", onChange: (e) => setFieldTypeSearchQuery(e.target.value), placeholder: "Find a field type", value: fieldTypeSearchQuery }))),
            React.createElement(ListBox, { className: "bg-transparent border-transparent", itemTemplate: fieldTypeItemTemplate, listClassName: "p-0", onChange: (e) => setModel(modelFactory(e.target.value, model.fieldName)), options: fieldTypesFactory(), optionValue: "dataType", value: model.dataType }))),
        model.dataType != null && (React.createElement("div", null,
            React.createElement("div", { className: "surface-600 p-3" },
                React.createElement(Dropdown, { className: "w-full", disabled: mode === "update", itemTemplate: fieldTypeItemTemplate, valueTemplate: fieldTypeItemTemplate, options: fieldTypesFactory(), optionValue: "dataType", onChange: (e) => setModel(modelFactory(e.target.value, model.fieldName)), value: model.dataType })),
            React.createElement("div", { className: "surface-900 p-3" }, renderDataTypeFields()),
            React.createElement("div", { className: "surface-600 p-3 border-round-bottom flex align-items-center justify-content-end" },
                React.createElement(Button, { className: "p-button-text", label: "Cancel", onClick: () => onCancel(), type: "button" }),
                React.createElement(Button, { label: mode === "update" ? "Update Field" : "Create Field", type: "submit" }))))));
    function isValid(model) {
        return model.dataType != null;
    }
    function onSubmit(e) {
        e.preventDefault();
        if (isValid(model)) {
            if (mode === "update") {
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(model);
            }
            else {
                onCreate === null || onCreate === void 0 ? void 0 : onCreate(model);
            }
        }
    }
    function modelFactory(dataType, fieldName = "") {
        switch (dataType) {
            case DataType.Boolean:
                return { dataType, fieldName, defaultValue: null, isMandatory: false };
            case DataType.DateTime:
                return {
                    dataType,
                    fieldName,
                    defaultValue: null,
                    parts: "date-time",
                    dateFormat: "",
                    timeFormat: "",
                    isMandatory: false,
                    isUnique: false,
                };
            case DataType.Number:
                return {
                    dataType,
                    fieldName,
                    defaultValue: null,
                    format: "integer",
                    precision: "1.0",
                    isMandatory: false,
                    isUnique: false,
                };
            case DataType.Text:
                return { dataType, fieldName, defaultValue: null, isMandatory: false, isUnique: false };
            case DataType.Uuid:
                return { dataType, fieldName, defaultValue: null, isMandatory: false, isUnique: false };
            default:
                return { dataType: undefined, fieldName };
        }
    }
    function fieldTypesFactory() {
        return [
            { dataType: DataType.Text, label: "Text" },
            { dataType: DataType.Number, label: "Number" },
            { dataType: DataType.Boolean, label: "Boolean" },
            { dataType: DataType.DateTime, label: "DateTime" },
            { dataType: DataType.Uuid, label: "Uuid" },
        ];
    }
    function fieldTypeItemTemplate(item) {
        return (React.createElement("div", { className: "flex align-items-center" },
            React.createElement("span", { className: classNames(getDataTypeIcon(item.dataType), "mr-2") }),
            item.label));
    }
    function renderDataTypeFields() {
        switch (model.dataType) {
            case DataType.Boolean:
                return renderDataTypeFieldsBoolean();
            case DataType.DateTime:
                return renderDataTypeFieldsDateTime();
            case DataType.Number:
                return renderDataTypeFieldsNumber();
            case DataType.Text:
                return renderDataTypeFieldsText();
            case DataType.Uuid:
                return renderDataTypeFieldsUuid();
            default:
                return null;
        }
    }
    function renderDataTypeFieldsBoolean() {
        if (model.dataType !== DataType.Boolean) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isMandatory, inputId: "boolean-is-mandatory", onChange: () => setModel(Object.assign(Object.assign({}, model), { isMandatory: !model.isMandatory })) }),
                " ",
                React.createElement("label", { htmlFor: "boolean-is-mandatory" }, "Is Mandatory?")),
            React.createElement("div", null,
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "boolean-default-value" }, "Default Value"),
                React.createElement(Dropdown, { className: "w-full", inputId: "boolean-default-value", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { defaultValue: e.target.value })), options: [
                        { label: "True", value: true },
                        { label: "False", value: false },
                    ], optionLabel: "label", optionValue: "value", value: model.defaultValue }))));
    }
    function renderDataTypeFieldsDateTime() {
        if (model.dataType !== DataType.DateTime) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "inline-block mb-2", htmlFor: "date-options" }, "Options"),
                React.createElement(Dropdown, { className: "w-full", inputId: "date-options", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { parts: e.target.value })), options: [
                        { label: "Date & Time", value: "date-time" },
                        { label: "Date Only", value: "date" },
                        { label: "Time Only", value: "time" },
                    ], optionLabel: "label", optionValue: "value", value: model.parts })),
            model.parts !== "time" && (React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "date-date-format" }, "Date Format"),
                React.createElement(InputText, { className: "w-full", id: "date-date-format", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { dateFormat: e.target.value })), placeholder: "Date Format", value: model.dateFormat }))),
            model.parts !== "date" && (React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "date-time-format" }, "Time Format"),
                React.createElement(InputText, { className: "w-full", id: "date-time-format", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { timeFormat: e.target.value })), placeholder: "Time Format", value: model.timeFormat }))),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isUnique, inputId: "date-is-unique", onChange: () => setModel(Object.assign(Object.assign({}, model), { isUnique: !model.isUnique })) }),
                " ",
                React.createElement("label", { htmlFor: "date-is-unique" }, "Is Unique?")),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isMandatory, inputId: "date-is-mandatory", onChange: () => setModel(Object.assign(Object.assign({}, model), { isMandatory: !model.isMandatory })) }),
                " ",
                React.createElement("label", { htmlFor: "date-is-mandatory" }, "Is Mandatory?")),
            React.createElement("div", null,
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "date-default-value" }, "Default Value"),
                React.createElement(Calendar, { className: "w-full", id: "date-default-value", onChange: (e) => { var _a; return setModel(Object.assign(Object.assign({}, model), { defaultValue: (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.toString() })); }, placeholder: "Default Value", value: model.defaultValue ? new Date(model.defaultValue) : undefined }))));
    }
    function renderDataTypeFieldsNumber() {
        if (model.dataType !== DataType.Number) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "inline-block mb-2", htmlFor: "number-format" }, "Format"),
                React.createElement(Dropdown, { className: "w-full", inputId: "number-format", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { format: e.target.value })), options: [
                        { label: "Integer", value: "integer" },
                        { label: "Decimal", value: "decimal" },
                    ], optionLabel: "label", optionValue: "value", value: model.format })),
            model.format === "decimal" && (React.createElement("div", { className: "mb-3" },
                React.createElement("label", { className: "inline-block mb-2", htmlFor: "number-precision" }, "Precision"),
                React.createElement(Dropdown, { className: "w-full", inputId: "number-precision", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { precision: e.target.value })), options: [
                        { label: "1.0", value: "1.0" },
                        { label: "1.00", value: "1.00" },
                        { label: "1.000", value: "1.000" },
                        { label: "1.0000", value: "1.0000" },
                        { label: "1.00000", value: "1.00000" },
                        { label: "1.000000", value: "1.000000" },
                        { label: "1.0000000", value: "1.0000000" },
                        { label: "1.00000000", value: "1.00000000" },
                    ], optionLabel: "label", optionValue: "value", value: model.precision }))),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isUnique, inputId: "number-is-unique", onChange: () => setModel(Object.assign(Object.assign({}, model), { isUnique: !model.isUnique })) }),
                " ",
                React.createElement("label", { htmlFor: "number-is-unique" }, "Is Unique?")),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isMandatory, inputId: "number-is-mandatory", onChange: () => setModel(Object.assign(Object.assign({}, model), { isMandatory: !model.isMandatory })) }),
                " ",
                React.createElement("label", { htmlFor: "number-is-mandatory" }, "Is Mandatory?")),
            React.createElement("div", null,
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "number-default-value" }, "Default Value"),
                React.createElement(InputNumber, { className: "w-full", inputId: "number-default-value", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { defaultValue: e.value })), placeholder: "Default Value", value: model.defaultValue }))));
    }
    function renderDataTypeFieldsText() {
        var _a;
        if (model.dataType !== DataType.Text) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isUnique, inputId: "text-is-unique", onChange: () => setModel(Object.assign(Object.assign({}, model), { isUnique: !model.isUnique })) }),
                " ",
                React.createElement("label", { htmlFor: "text-is-unique" }, "Is Unique?")),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isMandatory, inputId: "text-is-mandatory", onChange: () => setModel(Object.assign(Object.assign({}, model), { isMandatory: !model.isMandatory })) }),
                " ",
                React.createElement("label", { htmlFor: "text-is-mandatory" }, "Is Mandatory?")),
            React.createElement("div", null,
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "text-default-value" }, "Default Value"),
                React.createElement(InputText, { className: "w-full", id: "text-default-value", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { defaultValue: e.target.value })), placeholder: "Default Value", value: (_a = model.defaultValue) !== null && _a !== void 0 ? _a : "" }))));
    }
    function renderDataTypeFieldsUuid() {
        var _a;
        if (model.dataType !== DataType.Uuid) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isUnique, inputId: "uuid-is-unique", onChange: () => setModel(Object.assign(Object.assign({}, model), { isUnique: !model.isUnique })) }),
                " ",
                React.createElement("label", { htmlFor: "uuid-is-unique" }, "Is Unique?")),
            React.createElement("div", { className: "mb-3" },
                React.createElement(Checkbox, { checked: model.isMandatory, inputId: "uuid-is-mandatory", onChange: () => setModel(Object.assign(Object.assign({}, model), { isMandatory: !model.isMandatory })) }),
                " ",
                React.createElement("label", { htmlFor: "uuid-is-mandatory" }, "Is Mandatory?")),
            React.createElement("div", null,
                React.createElement("label", { className: "mb-2 inline-block", htmlFor: "uuid-default-value" }, "Default Value"),
                React.createElement(InputText, { className: "w-full", id: "uuid-default-value", onChange: (e) => setModel(Object.assign(Object.assign({}, model), { defaultValue: e.target.value })), placeholder: "Default Value", value: (_a = model.defaultValue) !== null && _a !== void 0 ? _a : "" }))));
    }
};

export { ColumnForm as default };
//# sourceMappingURL=ColumnForm.js.map
